<div class="catalog-content">
  <!-- Articles Form -->
  <app-catalogue-articles-form [enableCeoSpecificFields]="primaryTab==='CEO Desk'"
    (typeChange)="onTypeChange($event)"
    [articleData]="activeArticleData"
    [typeList]="typeList"
  ></app-catalogue-articles-form>
  <!-- Articles List -->
  <app-catalogue-articles-list [enableCeoSpecificFields]="primaryTab==='CEO Desk'"
    [data]="articleList"
    [type]="selectedType"
    (uploadThumbnailChange)="onUploadThumbnail($event)"
    (editChange)="onEdit($event)"
  ></app-catalogue-articles-list>
</div>
